export const SET_FILE = "SET_FILE";
export const SET_CONTACT = "SET_CONTACT";
export const SET_BILLING = "SET_BILLING";
export const SET_ACCOUNT = "SET_ACCOUNT";
